import { BuzerIcon } from "../../../BuzerIcons";

// Read-only completion-state dot — the display twin of CheckButton (which is the
// clickable toggle). All "active" states render in the theme colour, told apart
// by shape (v32.18): done = plná gulička (bez fajky) · miss = holé ✕ (bez kruhu)
// · skip = prázdny obrys. Two neutral states: off = prázdny obrys (nič dnes) ·
// muted = drobná bodka (nebolo naplánované). Used in the weekly table, history
// strip and legends.
export function StateDot({ state = "off", size = 15 }) {
  if (state === "muted") {
    return <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--field-border)",
      display: "inline-block", verticalAlign: "middle", flexShrink: 0 }} />;
  }
  const filled = state === "done";  // plná gulička, bez glyfu
  const bare = state === "miss";    // len ✕, bez kruhu
  const glyph = bare ? "close" : null;
  const outline = state === "off" ? "var(--field-border)" : "var(--brand-primary)";
  return (
    <span style={{ width: size, height: size, borderRadius: "50%", boxSizing: "border-box",
      background: filled ? "var(--brand-primary)" : "transparent",
      border: (filled || bare) ? "none" : "1.5px solid " + outline,
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      color: "var(--brand-primary)",
      /* lineHeight 0: glyf (✕) sedí presne v strede bunky */
      lineHeight: 0, verticalAlign: "middle", flexShrink: 0 }}>
      {glyph && <BuzerIcon name={glyph} size={Math.max(9, Math.round(size * 0.82))} color="currentColor" strokeWidth={3} />}
    </span>
  );
}
